<template>
    <div v-if="reservation" class="guest-invoices-layout-vertical vertical-layout vertical-menu-modern">
        <vertical-nav-menu :metadata="metadata">
            <template #header="slotProps">
                <slot name="vertical-menu-header" v-bind="slotProps" />
            </template>
        </vertical-nav-menu>
        <b-container fluid class="guest-invoices-layout-vertical__container w-100">
            <div
                v-if="invoicesTab == 'setup'"
                class="guest-invoices-layout-vertical__container__setup-cards-wrapper pt-2"
            >
                <setup-first-card
                    class="guest-invoices-layout-vertical__container__setup-cards-wrapper__first-card"
                    @loading="handleLoading"
                />
                <setup-second-card
                    class="guest-invoices-layout-vertical__container__setup-cards-wrapper__second-card"
                />
                <setup-third-card class="guest-invoices-layout-vertical__container__setup-cards-wrapper__third-card" />
                <setup-forth-card
                    class="guest-invoices-layout-vertical__container__setup-cards-wrapper__forth-card"
                    @refreshReservations="handleRefreshReservations"
                />
            </div>
            <guest-invoices-door-locks-tab
                v-if="invoicesTab == 'door-locks'"
                @refreshReservations="handleRefreshReservations"
            />
            <guest-invoices-guests-tab
                v-if="invoicesTab == 'guests'"
                @refreshReservations="handleRefreshReservations"
            />
            <guest-invoices-documents-tab
                v-if="invoicesTab == 'documents'"
                @refreshReservations="handleRefreshReservations"
            />
            <guest-invoices-commissions-tab
                v-if="invoicesTab == 'commissions'"
                @refreshReservations="handleRefreshReservations"
                @loading="handleLoading"
            />
            <guest-invoices-housekeeping-tab
                v-if="invoicesTab == 'housekeeping'"
                @refreshReservations="handleRefreshReservations"
            />
            <guest-invoices-history-tab
                v-if="invoicesTab == 'history'"
                @refreshReservations="handleRefreshReservations"
            />
            <guest-invoices-custom-tab
                v-if="invoicesTab == 'custom'"
                @refreshReservations="handleRefreshReservations"
                @loading="handleLoading"
            />
            <guest-invoices-correspondence-tab
                v-if="invoicesTab == 'correspondence'"
                @refreshReservations="handleRefreshReservations"
            />
            <guest-invoices-transactions-tab
                v-if="invoicesTab == 'transactions'"
                @refreshReservations="handleRefreshReservations"
                @loading="handleLoading"
            />
            <guest-invoices-triggers-tab
                v-if="invoicesTab == 'triggers'"
                @loading="handleLoading"
            />
            <guest-invoices-billing-tab
                v-if="invoicesTab == 'billing'"
                @refreshReservations="handleRefreshReservations"
                @loading="handleLoading"
            />
        </b-container>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VerticalNavMenu from './vertical-nav-menu/vertical-nav-menu.vue';
import SetupFirstCard from '../tabs/setup/first-card.vue';
import SetupSecondCard from '../tabs/setup/second-card.vue';
import SetupThirdCard from '../tabs/setup/third-card.vue';
import SetupForthCard from '../tabs/setup/forth-card.vue';
import GuestInvoicesGuestsTab from '../tabs/guests/guests.vue';
import GuestInvoicesDoorLocksTab from '../tabs/door-locks/door-locks.vue';
import GuestInvoicesDocumentsTab from '../tabs/documents/documents.vue';
import GuestInvoicesCommissionsTab from '../tabs/commissions/commissions.vue';
import GuestInvoicesHousekeepingTab from '../tabs/housekeeping/housekeeping.vue';
import GuestInvoicesHistoryTab from '../tabs/history/history.vue';
import GuestInvoicesCustomTab from '../tabs/custom/custom.vue';
import GuestInvoicesCorrespondenceTab from '../tabs/correspondence/correspondence.vue';
import GuestInvoicesTransactionsTab from '../tabs/transactions/transactions.vue';
import GuestInvoicesTriggersTab from '../tabs/triggers/triggers.vue';
import GuestInvoicesBillingTab from '../tabs/billing/billing.vue';

export default {
    components: {
        VerticalNavMenu,
        SetupFirstCard,
        SetupSecondCard,
        SetupThirdCard,
        SetupForthCard,
        GuestInvoicesGuestsTab,
        GuestInvoicesDoorLocksTab,
        GuestInvoicesDocumentsTab,
        GuestInvoicesCommissionsTab,
        GuestInvoicesHousekeepingTab,
        GuestInvoicesHistoryTab,
        GuestInvoicesCustomTab,
        GuestInvoicesCorrespondenceTab,
        GuestInvoicesTransactionsTab,
        GuestInvoicesTriggersTab,
        GuestInvoicesBillingTab,
    },
    data() {
        return {
            tabs: [
                { title: 'Setup', tab: 'setup' },
                { title: 'Door Locks', tab: 'door-locks' },
                { title: 'Guests', tab: 'guests' },
                {
                    title: 'Sent Message Log',
                    tab: 'conversations-send-message-log',
                },
                { title: 'Triggers', tab: 'triggers' },
                { title: 'Billing', tab: 'billing' },
                { title: 'Transactions', tab: 'transactions' },
                { title: 'Documents', tab: 'documents' },
                { title: 'Commissions', tab: 'commissions' },
                { title: 'Housekeeping', tab: 'housekeeping' },
                { title: 'History', tab: 'history' },
                { title: 'Custom', tab: 'custom' },
            ],
        };
    },
    computed: {
        ...mapGetters('guest', ['metadata', 'invoicesTab', 'reservation']),
    },
    methods: {
        handleLoading(loading) {
            this.$emit('loading', loading);
        },
        handleRefreshReservations(callback) {
            this.$emit('refreshReservations', callback);
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../../../scss/bootstrap-extended/bootstrap-extended.scss';

.guest-invoices-layout-vertical {
    min-height: 70vh;

    @include media-breakpoint-up(md) {
        display: flex;
    }

    &__container {
        box-shadow: 0 0 15px 0 #f2f2f2;
        padding-bottom: 2rem;
        min-height: 70vh;

        &__setup-cards-wrapper {
            display: grid;
            width: 100%;
            grid-column-gap: 15px;
            grid-row-gap: 15px;
            grid-auto-rows: auto;
            grid-template-columns: repeat(2, 1fr);

            &__first-card {
                grid-area: 1 / 1 / 2 / 2;
            }
            &__second-card {
                grid-area: 2 / 1 / 3 / 2;
            }
            &__third-card {
                grid-area: 1 / 2 / 2 / 3;
            }
            &__forth-card {
                grid-area: 2 / 2 / 3 / 3;
            }

            @include media-breakpoint-down(md) {
                display: flex;
                flex-direction: column;
            }
        }
    }
}
</style>
